import { TESTIDS } from "@/constants/testIds";

const LABELS = {
  discovery_presence: {
    title: "Discovery Presence",
    body: "How often your hotel is mentioned across search and AI answers.",
  },
  owned_authority: {
    title: "Owned Authority",
    body: "How often your official website is cited AND your content is the substantive answer.",
  },
  competitive_position: {
    title: "Competitive Position",
    body: "How often competitors and outside publishers own the answer instead of you (higher is better).",
  },
};

function tone(score) {
  if (score >= 75) return "score-strong";
  if (score >= 55) return "score-mid";
  return "score-low";
}

export default function SubScoresPanel({ subScores, opportunityLevel }) {
  if (!subScores) return null;
  return (
    <div className="grid md:grid-cols-4 gap-4">
      {Object.entries(LABELS).map(([key, meta]) => {
        const s = subScores[key];
        if (!s) return null;
        return (
          <div
            key={key}
            className="glass glass-hover rounded-2xl p-5"
            data-testid={TESTIDS.subScoreCard(key)}
          >
            <div className="label-eyebrow mb-2">{meta.title}</div>
            <div className={`font-serif text-5xl leading-none ${tone(s.score)}`}>{s.score}</div>
            <div className="font-mono text-xs mt-1 text-[color:var(--text-muted)]">
              /100 · {s.label}
            </div>
            <p className="text-xs text-[color:var(--text-secondary)] mt-3 leading-relaxed">
              {meta.body}
            </p>
          </div>
        );
      })}
      <div
        className="glass glass-hover rounded-2xl p-5"
        data-testid={TESTIDS.subScoreCard("content_opportunity")}
        style={{
          borderColor: "rgba(107,122,85,0.35)",
          background: "linear-gradient(135deg, rgba(107,122,85,0.05), transparent)",
        }}
      >
        <div className="label-eyebrow mb-2">Content Opportunity</div>
        <div className="font-serif text-5xl leading-none" style={{ color: "var(--brand-sage-deep)" }}>
          {opportunityLevel || "—"}
        </div>
        <div className="font-mono text-xs mt-1 text-[color:var(--text-muted)]">Level</div>
        <p className="text-xs text-[color:var(--text-secondary)] mt-3 leading-relaxed">
          How much lift is realistically available if you publish authoritative content on the
          identified gaps.
        </p>
      </div>
    </div>
  );
}
